import { Controller } from '@hotwired/stimulus'

const PUBLIC_PATHS = [
  '/',
  '/contact',
  '/terms-conditions',
  '/privacy-policy',
  '/about',
  '/report',
  '/speed-indicator',
  '/index-calculator',
  '/sale-and-purchase'
]

export default class extends Controller {
  static values = { loggedIn: Boolean }

  connect() {
    if (!this.isAppMode()) return
    if (!this.isPublicPage()) return
    if (this.isExternalLink()) return

    const redirectPath = this.loggedInValue ? '/vesselindex-lobby' : '/unauthorized'
    window.location.replace(redirectPath)
  }

  isAppMode() {
    return (
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      window.navigator.standalone === true ||
      (document.referrer && document.referrer.includes('android-app://')) ||
      navigator.userAgent.includes('VesselindexApp')
    )
  }

  isPublicPage() {
    const path = window.location.pathname
    return PUBLIC_PATHS.some((publicPath) => {
      if (publicPath === '/') return path === '/' || path === ''
      return path === publicPath || path.startsWith(publicPath + '?')
    })
  }

  isExternalLink() {
    const params = new URLSearchParams(window.location.search)
    return params.get('target') === '_blank'
  }
}
